import { inject } from '@angular/core';
import { CanActivateFn } from '@angular/router';
import { AuthService as Auth0Service } from '@auth0/auth0-angular';
import { map, take } from 'rxjs';
import { environment } from '../../environments/environment';
import { getTenantFromUrl } from '../shared/util/helpers/url.helper';

export const tenantValidityGuard: CanActivateFn = () => {
  const auth0Service = inject(Auth0Service);
  return auth0Service.user$.pipe(
    take(1),
    map((user) => {
      const tenant = getTenantFromUrl();
      // Auth0 types custom claims such as org_name as `any`.
      const orgName = user?.['org_name'] as string | undefined;
      const userTenant = orgName?.toLowerCase() || null;
      if (userTenant && tenant && userTenant !== tenant?.toLowerCase()) {
        window.location.href = `${environment.appUrl}/org/${orgName}`;
        return false;
      }

      return true;
    })
  );
};
